import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import DrawPolygonMap from './DrawPolygonMap';
import PlaceGeoSuggest from '../PlaceGeoSuggest/PlaceGeoSuggest';
import { googleMapLoader } from '../../../helpers/googleMapLoader';

import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from './GooglePolygonMap.css';

class GooglePolygonMap extends React.Component {

  static defaultProps = {
    label: '',
    className: '',
    defaultValue: '',
    containerClassName: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      noResult: false,
      lat: 37.0902,
      lng: -95.7129,
      sw_lat: 9.854550803628602,
      sw_lng: 80.12749270688475,
      ne_lat: 46.588831619427665,
      ne_lng: -120.63917188786621,
      googleMapsApiLoaded: false,
    };
  }

  async componentDidMount() {
    const { id, initialValue } = this.props;
    this.setState({ value: initialValue });
    await googleMapLoader();
    this.setState({ googleMapsApiLoaded: true });
  }

  handleSelectSuggest = (data) => {
    if (data) {
      let viewport, sw_lat, sw_lng, ne_lat, ne_lng, northEast, southWest;
      viewport = data?.viewport;
      northEast = viewport?.high;
      southWest = viewport?.low;
      sw_lat = southWest?.latitude;
      sw_lng = southWest?.longitude;
      ne_lat = northEast?.latitude;
      ne_lng = northEast?.longitude;
      this.setState({
        lat: data.location && data.location.latitude,
        lng: data.location && data.location.longitude,
        sw_lat,
        sw_lng,
        ne_lat,
        ne_lng
      })
    }

  }

  render() {
    const { label, className, defaultValue, containerClassName } = this.props;
    const { formName, fieldName, paths } = this.props;
    const { formatMessage } = this.props.intl;
    const { lat, lng, googleMapsApiLoaded, sw_lat, sw_lng, ne_lat, ne_lng } = this.state;

    return (
      <div>
        <label className={bt.commonLabelText} >{formatMessage(messages.searchLocation)}</label>
        <div className='commonLocationInput'>
          <PlaceGeoSuggest
            label={label ? label : formatMessage(messages.searchLocation)}
            placeholder={label ? label : formatMessage(messages.searchLocation)}
            initialValue={defaultValue}
            handleSelectSuggest={this.handleSelectSuggest}
            inputClass={cx(bt.formControlInput, 'form-control')}
            containerClassName={containerClassName}
          />
          {googleMapsApiLoaded &&
            <div>
              <DrawPolygonMap
                lat={lat}
                lng={lng}
                formName={formName}
                fieldName={fieldName}
                paths={paths}
                sw_lat={sw_lat}
                sw_lng={sw_lng}
                ne_lat={ne_lat}
                ne_lng={ne_lng}
              /> </div>
          }
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(bt, s)(GooglePolygonMap));